import React, { useEffect, useState } from 'react';

import get from 'lodash/get';
import isNil from 'lodash/isNil';

import Spinner from '@atlaskit/spinner';

import { StorageOfUniqueServices } from '@qality/common-service';

import { JiraAdminSettingsView } from './JiraAdminSettings.view';

const JiraAdminSettings: React.FC = () => {
  const [jiraAdminSettings, setJiraAdminSettings] = useState(null);

  useEffect(() => {
    const init = async () => {
      const settings = await StorageOfUniqueServices.get(
        'JiraAdminSettingsService'
      ).getJiraAdminSettings();
      setJiraAdminSettings(settings);
    };

    init();
  }, []);

  const qalityVisibilityChanged = () => {
    const isQalityForNewProjectsEnabled = !get(
      jiraAdminSettings,
      'isQalityForNewProjectsEnabled',
      true
    );
    saveAdminSettings({
      isQalityForNewProjectsEnabled,
      isPluginForNewProjectsEnabled:
        jiraAdminSettings.isPluginForNewProjectsEnabled,
    });
  };

  const pluginEnableChanged = () => {
    const isPluginForNewProjectsEnabled = !get(
      jiraAdminSettings,
      'isPluginForNewProjectsEnabled',
      true
    );
    saveAdminSettings({
      isQalityForNewProjectsEnabled:
        jiraAdminSettings.isQalityForNewProjectsEnabled,
      isPluginForNewProjectsEnabled,
    });
  };

  const saveAdminSettings = async (newAdminSettings) => {
    await StorageOfUniqueServices.get(
      'JiraAdminSettingsService'
    ).setJiraAdminSettings(newAdminSettings);
    setJiraAdminSettings(newAdminSettings);
  };

  if (!isNil(jiraAdminSettings)) {
    const isQalityForNewProjectsEnabled = get(
      jiraAdminSettings,
      'isQalityForNewProjectsEnabled',
      true
    );
    const isPluginForNewProjectsEnabled = get(
      jiraAdminSettings,
      'isPluginForNewProjectsEnabled',
      true
    );
    return (
      <JiraAdminSettingsView
        qalityVisibilityChanged={qalityVisibilityChanged}
        pluginEnableChanged={pluginEnableChanged}
        isQalityForNewProjectsEnabled={isQalityForNewProjectsEnabled}
        isPluginForNewProjectsEnabled={isPluginForNewProjectsEnabled}
      />
    );
  }
  return (
    <div className='section-content' style={{ paddingLeft: '50%' }}>
      <Spinner size='xlarge' />
    </div>
  );
};

export default JiraAdminSettings;
